import { createClient } from '@/shared/api';
import type { EditPhysicianNoteMutation, EditPhysicianNoteMutationVariables } from '@/shared/api';
import EDIT_PHYSICIAN_NOTE_MUTATION from '../mutations/editPhysicianNote';

/**
 * Saves an interpreting physician's note and signature against a study. Sends EDIT_PHYSICIAN_NOTE_MUTATION and throws the returned message when isSuccess is false, otherwise returning the payload or an empty object.
 *
 * @param studyFid - Facility study identifier the note belongs to.
 * @param note - Note text entered by the physician.
 * @param signature - Signature image reference attached to the note.
 * @returns The editPhysicianNote payload, or an empty object.
 */
const handleEditPhysicianNote = async (studyFid: number, note: string, signature: string) => {
  const client = createClient();
  const editPhysicianNoteResult = await client.mutate<
    EditPhysicianNoteMutation,
    EditPhysicianNoteMutationVariables
  >({
    mutation: EDIT_PHYSICIAN_NOTE_MUTATION,
    variables: {
      studyFid,
      note,
      signature,
    },
  });
  if (!editPhysicianNoteResult?.data?.editPhysicianNote?.isSuccess) {
    throw new Error(editPhysicianNoteResult?.data?.editPhysicianNote?.message ?? undefined);
  }
  return editPhysicianNoteResult?.data?.editPhysicianNote || {};
};

export default handleEditPhysicianNote;
